import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useOrderComplete from './hooks/useOrderComplete';

interface Params {
    orderNo: string;
}

const OrderCompleteActivity: ActivityComponentType<Params> = ({ params }: {params: Params}) => {
  const { orderNo } = params;
  useOrderComplete(orderNo);
  return (
        <AppScreen>
            <Header title='주문 완료' />
        </AppScreen>
  );
};

export default OrderCompleteActivity;
